// React
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// MUI
import { Grid, Box, Button } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
// Service
import { get, post, put } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Utils
import {
    InitialMainGroupLedgerAccountState,
    MainGroupLedgerAccountSchema,
    MainGroupLedgerAccountFormFields,
} from "./Configuration.utils";
// Styles
import { StyledDrawerForm } from "../../../configs/GoStyles";
//Third party
import { Form, Formik } from "formik";
import toast from "react-hot-toast";
import GoForm from "../../../components/Inputs/GoForm";
import PermissionConstants from "../../../configs/PermissionConstants";
import usePermissions from "../../../hooks/usePermissions";

const MainGroupLedgerAccount = ({ mainGroupLedger, mainGroupLedgerId, id, onClose }) => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [formFields, setFormFields] = useState(MainGroupLedgerAccountFormFields);
    const [main_group_ledger_account, setMainGroupLedgerAccount] = useState(InitialMainGroupLedgerAccountState);


    const attachOptions = (name, options) => {
        setFormFields(prevFormFields =>
            prevFormFields.map(field =>
                field.name === name && field.type === "select"
                    ? { ...field, options: options }
                    : field
            )
        );
    };

    const getSchoolsByCompanies = async () => {
        spinService.on();
        const response = await get(EntityConstants.SCHOOLSBYCOMPANIES);
        const data = await response.json();
        attachOptions("school_id", data);
        spinService.off();
    };

    const getAccounts = async (sub_account_id) => {
        spinService.on();
        const response = await get(EntityConstants.ACCOUNTS, `max=all&sub_account_id=${sub_account_id}`);
        const data = await response.json();
        attachOptions("account_id", data);
        spinService.off();
    };

    const getMainGroupLedgerAccount = async (id) => {
        spinService.on();
        const response = await get(EntityConstants.MAIN_GROUP_LEDGER_ACCOUNTS + `/${id}`);
        const data = await response.json();
        setMainGroupLedgerAccount(data);
        spinService.off();
    };

    const handleSubmit = async (values) => {
        spinService.on();
        values.main_group_ledger_id = mainGroupLedgerId;
        const isNewMainGroupLedgerAccount = values.id === undefined;
        const url = isNewMainGroupLedgerAccount ? EntityConstants.MAIN_GROUP_LEDGER_ACCOUNTS : EntityConstants.MAIN_GROUP_LEDGER_ACCOUNTS + `/${values.id}`;
        const method = isNewMainGroupLedgerAccount ? post : put;
        const response = await method(url, { main_group_ledger_account: values });
        if ([200, 201].indexOf(response.status) > -1) {
            toast.success(isNewMainGroupLedgerAccount ? MessageContants.MAIN_GROUP_LEDGER_ACCOUNT_CREATED : MessageContants.MAIN_GROUP_LEDGER_ACCOUNT_UPDATED);
            onClose();
        }
        spinService.off();
    };

    useEffect(() => {
        getSchoolsByCompanies();
        getAccounts(mainGroupLedger.sub_account_id)
        if (id !== undefined) {
            getMainGroupLedgerAccount(Number(id));
        }
    }, [id]);

    return (
        <Formik
            enableReinitialize
            initialValues={main_group_ledger_account}
            validationSchema={MainGroupLedgerAccountSchema}
            onSubmit={(values) => handleSubmit(values)}
        >
            {({
                values,
                touched,
                errors,
                dirty,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit,
            }) => (
                <Form noValidate onSubmit={handleSubmit}>
                    <StyledDrawerForm>
                        <Grid
                            container
                            maxWidth="sm"
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 2 }}
                        >
                            {formFields.map((formField, index) => {
                                return (
                                    <Grid key={index} item xs={12} sm={12} md={12} lg={12}>
                                        <GoForm
                                            config={formField}
                                            values={values}
                                            touched={touched}
                                            errors={errors}
                                            handleChange={handleChange}
                                        />
                                    </Grid>
                                );
                            })}
                        </Grid>
                        <Box sx={{ p: 2, textAlign: "right" }}>
                            <Button
                                variant="contained"
                                color="error"
                                startIcon={<Iconify icon="eva:close-circle-outline" />}
                                onClick={() => onClose()}
                            >
                                Close
                            </Button>
                            &nbsp;&nbsp;
                            {((values.id === undefined && permissions.has(PermissionConstants.BUS_DETAIL_CREATE)) || (values.id !== undefined && permissions.has(PermissionConstants.BUS_DETAIL_UPDATE))) &&
                                <Button
                                    variant="contained"
                                    startIcon={<Iconify icon="eva:save-fill" />}
                                    type="submit"
                                >
                                    {values.id === undefined ? 'Save' : 'Update'}
                                </Button>
                            }
                        </Box>
                    </StyledDrawerForm>
                </Form>
            )}
        </Formik>
    );
};

MainGroupLedgerAccount.propTypes = {
    id: PropTypes.number,
    onClose: PropTypes.any,
};

export default MainGroupLedgerAccount;